let uid = 0

export default class Node {

  constructor(data, config, parentNode) {
    this.data = data
    this.config = config
    this.parent = parentNode || null
    this.level = !this.parent ? 1 : this.parent.level + 1
    this.uid = uid++

    this.initState()
    this.initChildren()
  }

  initState() {
    const { value: valueKey, label: labelKey } = this.config
    this.value = this.data[valueKey]
    this.label = this.data[labelKey]
  }

  initChildren() {
    const { config } = this
    const childrenKey = config.children
    const childrenData = this.data[childrenKey]
    this.hasChildren = Array.isArray(childrenData)
    this.children = (childrenData || []).map(child => new Node(child, config, this))
  }
}